import React from 'react';
import ReactDOM from 'react-dom';

import SourceModeContainer from './source-mode-container';
import { panelEventsSubject } from 'ub/ui/inline-text/states/inline-text-state-subjects';
import {
  createSourceModeWrapper,
  removeSourceModeWrapper,
  clearFocusFromInlineText
} from './utils';
import jsBeautify from 'js-beautify';

let isOpen = false;

function buildSourceModeContainer(inlineTextStyleApi) {
  let newHtml = jsBeautify.html(inlineTextStyleApi.getHtml());

  const props = {
    htmlSource: newHtml,
    onChange: (html) => { newHtml = html; },
    onClose: () => {
      inlineTextStyleApi.setHtml(newHtml);
      panelEventsSubject.onNext({ type: 'toggleSourceMode' });
    },
    onSave: () => { inlineTextStyleApi.setHtml(newHtml); }
  };

  return (
    <SourceModeContainer {...props} />
  );
}

let sourceModeWrapper = null;

function close() {
  ReactDOM.unmountComponentAtNode(sourceModeWrapper);
  removeSourceModeWrapper(sourceModeWrapper);
  isOpen = false;
}

function open(inlineTextStyleApi) {
  // Greasy hack cause JUI sucks. see https://github.com/unbounce/lp-builder/blob/a8bdf1c31a50c3bb734bb03ed1cd7c3c7bfbd119/src/legacy/lp/modules/lp-root/root_element_properties_panel.js#L502
  // this removes the focus from the inline text element, and prevents you from entering
  //  source edit mode while still having focus on the text-element-inline
  clearFocusFromInlineText();

  const container = buildSourceModeContainer(inlineTextStyleApi);
  sourceModeWrapper = createSourceModeWrapper();

  ReactDOM.render(container, sourceModeWrapper);

  isOpen = true;
}

function toggle(inlineTextStyleApi) {
  if (isOpen) {
    close();
  } else {
    open(inlineTextStyleApi);
  }
}

export default {
  toggle,
  close,
  open
};



// WEBPACK FOOTER //
// ./src/ui/inline-text/source-mode-components/source-mode.jsx